import { Card, CardContent, CardHeader, ContactInfoRow, SingleInfoCard, useRouter } from '@forgeglobal/design-framework'
import { Routes } from 'util/Routes'
import { TradeIntentType, useOpportunityAccountQuery } from 'graphql/bindings/AdminBindings'
import { getGravatarUrl } from 'util/GravatarUtil'
import React from 'react'

export const OpportunityAccountPanel: React.FC = () => {
  const { match } = useRouter<{ id: string }>()
  const { data } = useOpportunityAccountQuery({ variables: { opportunityId: match.params.id } })
  const opportunity = data?.opportunity
  const account = opportunity?.account
  const tradeIntentType = opportunity?.trade_intent?.type ?? TradeIntentType.Bid
  const parents = account?.parents ?? []
  const subtitle = parents.length ? `${parents[0].title} at ${parents[0].parent_account.name}` : ''
  const email = account?.email ?? ''
  const phone = account?.formatted_phone_number ?? ''
  const gravatarUrl = getGravatarUrl(email)
  return (
    <Card>
      <CardHeader title={tradeIntentType === TradeIntentType.Bid ? 'Buyer' : 'Seller'} />
      <CardContent>
        <SingleInfoCard
          leftTitle={account?.name ?? ''}
          logo={gravatarUrl}
          leftSubtitle={subtitle}
          notes={(phone || email) && <ContactInfoRow phone={phone} email={email} />}
          link={Routes.account(account?.id)}
        />
      </CardContent>
    </Card>
  )
}
